package app.alefly.domain.model

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@JvmInline
@Serializable
value class TenantId(val value: String)

@JvmInline
@Serializable
value class QuizId(val value: String)

@JvmInline
@Serializable
value class QuestionId(val value: String)

@JvmInline
@Serializable
value class ChallengeId(val value: String)

@JvmInline
@Serializable
value class ClientId(val value: String)
